module.exports = __webpack_public_path__ + "media/images/clse-c11288da0a571d6a1d02730d415bdd43.png";